<template>
  <block
    component-name="block-text-chapter-rich"
    body-class="flex flex-col gap-3xl"
  >
    <header class="flex flex-col w-9/12 gap-xs">
      <wrapper-reveal v-if="$attrs.data.body.overline" reveal="fade-from-right">
        <div class="text-overline-big" v-html="$attrs.data.body.overline"></div>
      </wrapper-reveal>

      <wrapper-split-text reveal="chars">
        <h1 class="text-heading-3" v-html="$attrs.data.body.title"></h1>
      </wrapper-split-text>
    </header>

    <div
      v-if="$attrs.data.body.text || $attrs.data.body.button"
      class="flex flex-col gap-3xl w-10/12 laptop:w-8/12 mx-auto @container/txt-chapter-rich-body"
    >
      <wrapper-reveal
        v-if="$attrs.data.body.text"
        reveal="fade-from-bottom"
        class="w-full"
      >
        <p
          class="@[720px]/txt-chapter-rich-body:columns-2 @[720px]/txt-chapter-rich-body:gap-2xl text-heading-6 w-full"
          v-html="$attrs.data.body.text"
        ></p>
      </wrapper-reveal>

      <wrapper-reveal
        v-if="$attrs.data.body.button"
        class="self-start mt-3xl"
        reveal="fade-from-right"
      >
        <btn-pill
          size="big"
          :title="$attrs.data.body.button.title"
          :icon="$attrs.data.body.button.icon || undefined"
          :action="$attrs.data.body.button.action"
        />
      </wrapper-reveal>
    </div>
  </block>
</template>
